import { createFileRoute } from "@tanstack/react-router"

// Import the existing search page
import SubmissionSearchPage from "@/features/jobs/search/components/submission-search-page"

export const Route = createFileRoute("/_screen/s/submission")({
  component: SearchSubmissionPage
})

function SearchSubmissionPage() {
  return <SubmissionSearchPage />
}
